import styled from 'styled-components';

export const StyledHeader = styled.header`
  display:flex;
  justify-content:space-between;
  align-items:center;

  width:100%;
  height:3rem;
  padding:2rem;
  background-color:black;
  font-size:2rem;
  color:white;

  a{
    color:white
  }

`;

